import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { crearNivelConfiguracion } from '../../../actions/configuracion';

const NuevoNivel = ({ nivel, reestablecerNivel }) => {

    const dispatch =  useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [nivelData, setNivelData] = useState({
        nombre: null, 
        orden: null
    });

    /* Crear nivel */
    const handleInputChange = ({ target }) => {
        setNivelData({
            ...nivelData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(nivelData.nombre && nivelData.orden){
            await setStatusProcesar(true);
            await dispatch(crearNivelConfiguracion(nivelData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setNivelData({
                nombre: null, 
                orden: null
            });

            setNuevoModal(false);

            reestablecerNivel(null);
        }
    }

    useEffect(() => {
        if(nivel){
            setNuevoModal(true);

            setNivelData({
                ...nivelData
            });
        }        
    }, [nivel]);

    return (
        <Fragment>
            <Modal show={nuevoModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar nivel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group mb-3 col-md-8">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={nivelData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group mb-3 col-md-4">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="number" className="form-control" placeholder="Orden" id="orden" name="orden" value={nivelData.orden} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="orden">Orden</label>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                        :
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default NuevoNivel;